import { FeedbackContextProvider } from "./feedback_context_provider";
import { ParticipantsOverview } from "./participants_overview";

export const ActivityFeedback = (): JSX.Element => (
  <FeedbackContextProvider>
    <ParticipantsOverview />
  </FeedbackContextProvider>
);
